

<template>
    <Menu as="div" id="onboarding-builder-download" data-step="8" class="relative inline-block text-left">
        <MenuButton
            :disabled="loadingDownload"
            as="div"
        >
            <div
                v-if="slots.button == null"
                class="flex items-center justify-center cursor-pointer rounded select-none h-8 w-[138px] py-[10px] px-[8px] bg-[#b6dbc4]"
            >
                <svg v-if="loadingDownload" class="animate-spin -ml-1 mr-3 h-5 w-5 won-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>

                <span class="won-blue text-sm font-medium">Download</span>
            </div>

            <slot name="button" v-else></slot>
        </MenuButton>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems
                :static="isOnboarding && onboardingStep === 'onboarding-builder-download'"
                class="absolute right-0 z-10 mt-2 w-[138px] origin-top-right rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
                <div class="py-1">
                    <MenuItem v-slot="{ active }">
                        <div
                            @click="() => handleDownload(DOCUMENT_PDF)"
                            :class="[active ? 'bg-[#F4F4F4]' : '', 'cursor-pointer block px-2 py-1 leading-[14px] font-normal text-[12px] flex items-center justify-start text-[#073B5D]']"
                        >
                            <DownloadIcon class="mr-1" />Download PDF
                        </div>
                    </MenuItem>
                    <MenuItem v-slot="{ active }" v-if="allowDownloadDOCX()">
                        <div
                            @click="() => handleDownload(DOCUMENT_DOCX)"
                            :class="[active ? 'bg-[#F4F4F4]' : '', 'cursor-pointer block px-2 py-1 leading-[14px] font-normal	text-[12px] flex items-center justify-start text-[#073B5D]']"
                        >
                            <DownloadIcon class="mr-1" />Download DOCX
                        </div>
                    </MenuItem>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script setup>
import { useSlots } from "vue";
import { allowDownloadDOCX } from "../../../utils/helpers";
import { DOCUMENT_DOCX, DOCUMENT_PDF } from "../../../store/builder-style.store";

import {
    Menu,
    MenuItem,
    MenuButton,
    MenuItems
} from "@headlessui/vue";
import DownloadIcon from '../../../icons/download'

const emit = defineEmits(['download'])
const props = defineProps({
    isOnboarding: {
        type: Boolean,
        default: false
    },
    loadingDownload: {
        type: Boolean,
        default: false
    },
    onboardingStep: {
        type: String,
        default: ''
    }
})

const slots = useSlots();

const handleDownload = (docType) => {
    emit('download', docType)
}
</script>
